import { render, staticRenderFns } from "./PaKolSetting.vue?vue&type=template&id=1ac41a67&scoped=true"
import script from "./PaKolSetting.vue?vue&type=script&lang=js"
export * from "./PaKolSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac41a67",
  null
  
)

export default component.exports